import React from 'react';
import PropTypes from 'prop-types';
// import defaultLogo from 'assets/img/icon-logo.svg';

const Loader = ({ customLogo }) => {
  return (
    <div className="full-loader-wrapper">
      <div className="inner-loader-wrapper rounded-circle">
        <div className="loading-circle">
          <img className="icon-logo-loader" src={customLogo} alt="" />
        </div>
      </div>
    </div>
  )
};

Loader.defaultProps = {
  customLogo: '',
}

Loader.propTypes = {
  customLogo: PropTypes.string,
}

export default Loader;
